/** @file DialogLayer: renders the dialog `shell.dialog` names (About, Guides, Shortcuts); closing clears it. */
import type { ReactElement } from 'react';
import type { Binding } from '@zilo/pose3d-shortcuts/types';
import { useEditor } from '../state/useEditor';
import { useEditorStore } from '../state/useEditorStore';
import { AboutDialog } from './AboutDialog';
import { GuidesDialog } from './GuidesDialog';
import { ShortcutsDialog } from './ShortcutsDialog';

/** The tables and overrides the shortcuts dialog lists. */
export type DialogLayerProps = { bindingTables: Binding[][]; overrides: Binding[] };

/** At most one dialog; `newPuppet` is drawn by the Puppets screen, not here. */
export function DialogLayer({ bindingTables, overrides }: DialogLayerProps): ReactElement | null {
  const store = useEditorStore();
  const dialog = useEditor((s) => s.shell.dialog);
  const close = (): void => { store.getState().setShell({ dialog: null }); };
  switch (dialog) {
    case 'about': return <AboutDialog onClose={close} />;
    case 'guides': return <GuidesDialog onClose={close} />;
    case 'shortcuts': return <ShortcutsDialog bindingTables={bindingTables} overrides={overrides} onClose={close} />;
    case 'newPuppet':
    case null: return null;
  }
}
